import { render } from "./Instructors.vue?vue&type=template&id=83505aae"
import script from "./Instructors.vue?vue&type=script&lang=js"
export * from "./Instructors.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__